import type { Language } from '@/types/index';
import { categoriesApi, placesApi, articlesApi } from '@/lib/api';
import { useOptimizedQuery } from './useOptimizedQuery';

export function useCategoryDetail(slug: string, language: Language) {
  const categoryQuery = useOptimizedQuery({
    queryKey: ['category', slug, language],
    queryFn: () => categoriesApi.getBySlug(slug, language),
    enabled: !!slug,
    tier: 'updatable',
  });

  const placesQuery = useOptimizedQuery({
    queryKey: ['places', slug, language],
    queryFn: () => placesApi.getByCategory(language, slug),
    enabled: !!slug,
    tier: 'updatable',
  });

  const articlesQuery = useOptimizedQuery({
    queryKey: ['articles', 'category', slug, language],
    queryFn: () => articlesApi.getByCategory(language, slug),
    enabled: !!slug,
    tier: 'updatable',
  });

  return {
    category: categoryQuery.data,
    places: placesQuery.data || [],
    articles: articlesQuery.data || [],
    isLoading: categoryQuery.isLoading || placesQuery.isLoading || articlesQuery.isLoading,
    error: categoryQuery.error || placesQuery.error || articlesQuery.error,
  };
}
